var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"4em"}},[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Vue Todo List")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }